let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2gRyj")).then(() => parcelRequire('79rNS'));